import { ApolloClientProvider } from './state/apollo';
import { AuthProvider } from './state/auth';
import { CTGLoyaltyProvider } from './state/ctg-loyalty-legacy';
import { IntlProvider } from './state/intl';
import { LocationProvider } from './state/location';
import { MParticleProvider } from './state/mparticle';
import { NotificationProvider } from './state/notification';
import { ParamsProvider } from './state/params';
import { ThemeProvider } from './state/theme';
import { UniversalSearchProvider } from './state/universal-search';

const providers = [
  ThemeProvider,
  IntlProvider,
  NotificationProvider,
  AuthProvider,
  ApolloClientProvider,
  LocationProvider,
  ParamsProvider,
  CTGLoyaltyProvider,
  MParticleProvider,
  UniversalSearchProvider,
];

export default providers;
